import React, { useMemo } from "react";
import { FaCalendar } from "react-icons/fa";

const StatsCard = ({ contractSummary }) => {
  const stats = useMemo(() => [
    { title: "Total Booking", count: contractSummary?.total_contracts || 0, bgColor: "bg-blue-100", iconColor: "text-blue-500" },
    { title: "Booking Success", count: contractSummary?.booking_success || 0, bgColor: "bg-green-100", iconColor: "text-green-500" },
    { title: "Booking Cancelled", count: contractSummary?.booking_pending || 0, bgColor: "bg-red-100", iconColor: "text-red-500" },
  ], [contractSummary]); 

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4 sm:px-8">
      {stats.map((item, index) => (
        <div 
          key={index} 
          className="bg-white w-full min-w-[180px] max-w-[300px] md:max-w-[350px] lg:max-w-[350px] px-6 rounded-lg shadow-md custom-max-w"
        >
          <div className="flex items-center justify-between py-4">
            <div className="flex flex-col">
              <div className="text-gray-500 font-Montserrat text-sm">{item.title}</div>
              <div className="text-black text-2xl font-Montserrat font-bold tracking-tight">{item.count}</div>
            </div>
            <div
              className={`flex ${item.bgColor} rounded-[5px] p-3 w-[50px] h-[50px] justify-center items-center`}
            >
              <FaCalendar className={`${item.iconColor} text-xl`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCard;
